import { render } from "./MonthlyReport.vue?vue&type=template&id=7a8dcb60"
import script from "./MonthlyReport.vue?vue&type=script&lang=js"
export * from "./MonthlyReport.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__